export default {
    title: "Something went wrong",
    description:
        "We're sorry, an unexpected error has occurred. Our team has been notified and is working to resolve the issue.",
    tryAgain: "Try again",
    goHome: "Home Page",
    helpText: "If the problem persists, please contact our",
    supportTeam: "support team",
};
